module.exports = __webpack_public_path__ + "img/6_dice[6].c37582b3.png";